export const USERS_PATH = '/users';
export const SPECIES_BREEDS_PATH = '/species-breeds';
export const PRACTICES_PATH = '/practices';
export const OFFERS_PATH = '/offers';
